export const LOCAL_STORAGE_KEY = {
    APP_BUILD_VERSION: 'app_build_version',
    // If true, logInDev will log to the console even in production
    ENABLE_DEV_INFO: 'enable_dev_info',
    LD_ANONYMOUS_USER_KEY: 'ld-anonymous-user-key',
    FINGERPRINT: 'fingerprint',
} as const;

export const TERMINATE_REQUEST = 'terminate_request';
